import { Expose } from 'class-transformer';

export class TranslatedObjectModel {
  @Expose() en: string;
  @Expose() ar: string;
}
